import { elementConstants } from "../../constants/cms/form/element/element.constants";

export const paymentOptions = [
  {
    id: "DIBS",
    type: elementConstants.PAYMENT_OPTIONS,
    url:
      "https://cdn.dibspayment.com/logo/checkout/combo/vert/DIBS_checkout_kombo_vertical_01.png"
  },
  {
    id: "INVOICE",
    type: elementConstants.PAYMENT_OPTIONS
  }
];
